export const sizeMapping = {
  'Extra Large': 'XL',
  'Medium': 'M',
  'Large': 'L',
  'Extra Extra Large': 'XXL',
  'M': 'M',
  'XL': 'XL',
  'L': 'L',
  'XXL': 'XXL',
};
export const sizeString = (size) => {
  const sizeObj = {
    S: 'Small',
    L: 'Large',
    M: 'Medium',
    XL: 'Extra Large',
    XXL: 'Extra Extra Large',
  };
  if (sizeObj[size]) {
    return sizeObj[size];
  } else return size;
};
export const breadCrumbsData = [
  {
    name: 'HOME',
    deeplinkValue: '/',
  },
  {
    name: 'MOM CARE PRODUCTS',
    deeplinkValue: '/category/mom-care-products-6113',
  },
  {
    name: 'MATERNITY DRESSES',
    deeplinkValue: '/',
  },
];
